/* eslint-disable react/no-array-index-key */
import { Modal, Tooltip } from "@gw/web-basic-components";
import React, { useEffect, useRef, useState } from "react";
import { LoopSelectProps } from "./dto";
import { cn } from "../../../utils";
import { useLatest, useMemoizedFn } from "ahooks";

const getTotal = (list: number[], idx: number, defaultValue = 0) =>
  list.slice(0, idx).reduce((pre, cur) => pre + (cur ?? defaultValue), 0);

const LoopSelect = ({ items, onChange }: LoopSelectProps) => {
  const [dragging, setDragging] = useState<number[]>([]);
  const startIdxRef = useRef<number>();
  const handleChange = useMemoizedFn(onChange);

  const draggingLatest = useLatest(dragging);
  const itemsLatest = useLatest(items);

  const handleMouseUp = () => {
    if (startIdxRef.current === undefined) return;
    startIdxRef.current = undefined;
    const [startIdx] = draggingLatest.current,
      endIdx = draggingLatest.current[draggingLatest.current.length - 1];
    const { minRow } = itemsLatest.current[startIdx];
    const { maxRow } = itemsLatest.current[endIdx];
    Modal.confirm({
      title: `确认添加此多行数据【${minRow} - ${maxRow}】？`,
      onOk: () => {
        handleChange?.("add", draggingLatest.current);
        setDragging([]);
      },
      onCancel: () => {
        setDragging([]);
      },
    });
  };

  useEffect(() => {
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  return (
    <div className="wbuc-absolute -wbuc-left-[0.625rem] wbuc-top-0 wbuc-h-full wbuc-w-[0.625rem] wbuc-overflow-hidden wbuc-rounded-s-[0.5rem] wbuc-bg-[rgb(239,240,241)]">
      {items?.map((i, idx) => (
        <Tooltip key={idx} title={i.tooltip}>
          <div
            className={cn(
              "wbuc-absolute wbuc-w-full",
              i.loop || dragging.includes(idx)
                ? "wbuc-bg-[#3B65EE]"
                : "hover:wbuc-bg-[rgb(222,224,227)]",
              i.disabled ? "wbuc-cursor-not-allowed" : "wbuc-cursor-pointer"
            )}
            style={{
              height: i.height + 1,
              transform: `translateY(${getTotal(
                items?.map((item) => item.height) ?? [],
                idx
              )}px)`,
            }}
            onClick={() => {
              if (!i.loop || i.disabled) return;
              Modal.confirm({
                title: "确认删除此多行数据？",
                onOk: () => {
                  handleChange?.("remove", [idx]);
                },
              });
            }}
            onMouseDown={() => {
              if (i.loop || i.disabled) return;
              startIdxRef.current = idx;
              setDragging([idx]);
            }}
            onMouseMove={(e) => {
              if (startIdxRef.current === undefined || i.disabled) return;
              e.preventDefault();
              if (i.loop) {
                return handleMouseUp();
              }
              setDragging(
                Array.from(
                  { length: Math.abs(idx - startIdxRef.current) + 1 },
                  (_, index) => index + Math.min(idx, startIdxRef.current)
                )
              );
            }}
          />
        </Tooltip>
      ))}
    </div>
  );
};

export default LoopSelect;
